export default __webpack_public_path__ + "static/media/icon-coin-blur.c106bfb5.svg";